import { Component, OnInit } from '@angular/core';
import { waterwaysActions, waterwaysSelector } from '@app/core/store/waterways/waterways.slice';
import { createMapUrl } from '@app/utils';
import { Store } from '@ngrx/store';
import _ from 'lodash';

@Component({
  selector: 'app-landing-find-waterways',
  templateUrl: './find-waterways.component.html',
  styleUrls: ['./find-waterways.component.scss'],
})
export class FindWaterwaysComponent implements OnInit {
  regions$: any;

  constructor(private store: Store<{}>) {}

  stateUrl(region) {
    return createMapUrl({ IsoCountryCode: region.IsoCountryCode, State: region.name });
  }

  ngOnInit() {
    this.store.dispatch(waterwaysActions.getRegions());
    this.regions$ = this.store.select(waterwaysSelector.getRegions);
  }
}
